let worker

export const getUploadWorker = () => {
	if (!worker) {
		worker = new Worker(new URL("./UploadWorkerInstance.js", import.meta.url), {
			name: "upload worker",
			type: "module",
		})
	}

	return worker
}
